import { useOutletContext } from 'react-router-dom';
import CompanyActivityChart from './components/CompanyActivityChart';

const CompanyActivityTab = () => {
  const { requests_by_company } = useOutletContext();
  return <CompanyActivityChart data={requests_by_company} />;
};

export default CompanyActivityTab;
